import { memo } from "react"
import { DTO_Dashboard, DTO_SpeedViolations } from "../../../services/calls/types/dashboard"
import { CARD_KEYS } from "../Card/data"
import { useCardDetails } from "./useCardDetails"

import './index.scss'

export type DashboardData = DTO_Dashboard & { speed_violations: DTO_SpeedViolations[]}

type CardDetails = {
  card: CARD_KEYS
  data: DashboardData | undefined
}

const CardDetails = memo(({ card, data = {} }: CardDetails) => {
  const { graph, table, info } = useCardDetails(card, data)
  return (
    <div className="CardDetails">
      {graph}
      {table}
      {info}
    </div>
  )
})

export default CardDetails
